<!--
Author: TangChen
Date: 2018-02-26
Desc: 购买基金组件，由index.js 配置引入
-->
<template>
    <div class="comp-buy comp">
        <el-form
            v-show="!buySuccess"
            ref="fundInfo"
            :model="fundInfo"
            :rules="rules"
            label-width="260px"
            class="pwdForm"
            inline-message
            v-on:submit.native.prevent
        >
            <el-form-item v-if="fund.combinationcode" label="组合代码：" class="form-text">
                <div v-cloak class="text-con">
                    {{ fund.combinationcode }}
                </div>
            </el-form-item>
            <el-form-item v-if="fund.comrate" label="基金代码：" class="form-text">
                <div v-cloak class="text-con">
                    {{ fund.fundCode }}
                </div>
            </el-form-item>
            <el-form-item v-if="fund.comrate" label="基金名称：" class="form-text">
                <div v-cloak class="text-con">
                    {{ fund.fundName }}
                </div>
            </el-form-item>
            <el-form-item v-else label="基金名称：" class="form-text">
                <div v-cloak class="text-con">
                    {{ fund.fundname+'('+ fund.fundcode +')' }}
                </div>
            </el-form-item>
            <el-form-item v-if="fund.comrate" label="投资比例：" class="form-text">
                <div v-cloak class="text-con">
                    {{ fund.comRate }}
                </div>
            </el-form-item>
            <el-form-item v-if="fund.payway" label="支付方式：" prop="way" class="form-text">
                <el-radio-group v-model="fundInfo.way">
                    <el-radio v-if="fund.payway.indexOf('1')>-1" label="1" name="sell">
                        现金宝<span>(可用余额：<span
                            class="red"
                        >{{ $util.fmtNum(xjbAll) }}</span>元)</span>
                    </el-radio>
                    <el-radio v-if="fund.payway.indexOf('2')>-1" label="2" name="sell">
                        银行卡
                    </el-radio>
                    <el-radio v-if="fund.payway.indexOf('3')>-1" label="3" name="sell">
                        汇款
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="支付渠道：" prop="pay" class="payway-list">
                <el-select
                    v-if="fundInfo.way!=='1' && bankLists.length > 0"
                    v-model="fundInfo.pay"
                    placeholder="请选择支付方式"
                    :class="{'hasVal':bankInfo && bankInfo.label}"
                    v-on:change="bankSel"
                >
                    <el-option-group
                        v-for="(group,index) in bankLists"
                        :key="index"
                        :label="group.label"
                        class="bank-sel"
                        style="width:100%"
                    >
                        <el-option
                            v-for="item in group.options"
                            :key="item.moneyaccount"
                            :label="item.label"
                            :value="item.moneyaccount"
                        >
                            <div v-if="!item.bankAdd" class="bank-info">
                                <img :src="$util.getImg(item.bankid)">
                                <span>{{ $util.getDimCard(item.label) }}</span>
                                <p v-if="!item.bankAdd">
                                    {{ item.text }}
                                </p>
                            </div>
                            <div v-if="item.bankAdd" class="option-group clear">
                                {{ item.bankCate }}
                                <span>
                                    {{ item.bankAdd }}
                                </span>
                            </div>
                        </el-option>
                    </el-option-group>
                </el-select>
                <div v-if="fundInfo.way!=='1' && bankInfo && bankInfo.label" class="el-select-img">
                    <img
                        :src="$util.getImg(bankInfo.bankid)"
                    >
                    <span class="k-text-flow">{{ $util.getDimCard(bankInfo.label) }}</span>
                </div>
                <el-radio-group v-if="(fundInfo.way==='1' && xjbInfo.length===0)||(fundInfo.way!=='1' && bankLists.length === 0)" class="bank-radio">
                    <el-radio label="no-selec" border>
                        <div class="bank-img-sel">
                            <div v-if="fundInfo.way==='1'" class="k-text-flow">
                                您的现金宝还未充值，请立即<span
                                    class="like-a"
                                    v-on:click="$router.push({name:'currencycharge'})"
                                >前往充值</span>
                            </div>
                            <div v-else class="k-text-flow">
                                您还未添加银行卡，请联系客服添加
                            </div>
                        </div>
                    </el-radio>
                </el-radio-group>
                <el-radio-group
                    v-if="fundInfo.way==='1' && xjbInfo.length>0"
                    v-model="fundInfo.pay"
                    class="bank-radio"
                >
                    <el-radio
                        v-for="bank in xjbInfo"
                        :key="bank.transid+bank.xjbfundcode"
                        :label="bank.transid+bank.xjbfundcode"
                        border
                    >
                        <div class="bank-img-sel">
                            <img :src="$util.getImg(bank.bankid)">
                            <div class="k-text-flow">
                                <span class="bank-name" :title="$cache.getDict('150003',bank.bankid)">{{ $cache.getDict('150003',bank.bankid).toString().substr(0,6) }}</span>总额(元):<span
                                    class="bank-balance"
                                >{{ $util.fmtNum(bank.totalasset) }}</span>
                            </div>
                            <i class="el-icon-check" />
                        </div>
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-show="fund.sharetype === 'A,B'" label="收费方式：" prop="way" class="form-text">
                <el-radio-group v-model="fundInfo.sharetype">
                    <el-radio label="A" name="share">
                        前收费
                    </el-radio>
                    <el-radio label="B" name="share">
                        后收费
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="购买金额：" prop="amount" class="redemp-amount" :class="fund.sign&&!isPwdCheck?(!fund.comrate?'':'form-text'):''">
                <el-input
                    v-model.trim="fundInfo.amount"
                    class="prefix"
                    :placeholder="pla"
                    :maxlength="14"
                    prefix-icon="fa fa-jpy"
                />
                <p v-if="!fund.comrate" class="redemp-prompt">
                    <i class="el-icon-warning" /><span
                        v-if="false"
                        class="red"
                    >购买金额以10的倍数递增，</span><span>{{ fund.fundtype ===
                        '2'?'货币基金零费率':('买入费率' + fund.feerate) }}</span><span v-if="fund.isBuy===''">{{ '，预计'
                        + $util.fmtDate(fund.cfmdate) }}确认份额</span>
                </p>
            </el-form-item>
            <el-form-item v-show="feeGate.charge" label="预估手续费：" class="form-text">
                <div class="text-con" v-html="feeH" />
            </el-form-item>
            <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd" :class="{'form-text':fund.sign}">
                <el-input
                    v-model.trim="fundInfo.pwd"
                    type="password"
                    placeholder="请输入交易密码"
                    :maxlength="16"
                />
                <!--<span class="redemp-btn" v-on:click.prevent="$router.push({name: 'tradepwd'})"><span class="like-a">忘记密码？</span></span>-->
            </el-form-item>
            <el-form-item v-if="fund.sign" label="" prop="protocol" class="check">
                <el-checkbox-group v-model="fundInfo.protocol" class="protocol">
                    <fund-protocol :fund="fund" />
                </el-checkbox-group>
            </el-form-item>
            <el-form-item style="margin-left:-80px">
                <div v-if="readFileInfoList.length!==0" class="check-box bar-pad showChenckbox" style="font-size: 14px; display: flex; align-items: flex-start;">
                    <div style="display: flex; align-items: center;">
                        <input v-model="checkbox" type="checkbox" />
                        <span style="padding-left:5px;color:red;">我已阅读并同意: </span>
                    </div>
                    <ul>
                        <li v-for="(item,index) in readFileInfoList" :key="index">
                            <!--<a v-if="item.textaddress.startsWith('http')" v-on:click="getClick(index)" :href="item.textaddress"  style="text-decoration:none; color: red" target="_blank">《{{item.textname}}》</a>-->
                            <!--<span v-else v-on:click="showPdf(item.textaddress)">《{{item.textname}}》</span>-->
                            <a
                                v-if="$cache.getCompanyInfo().pdf_open_way === '0'"
                                target="_blank"
                                v-on:click="getClick(index)"
                            >《{{ item.textname }}》</a>
                            <a v-else :href="item.textaddress" style="text-decoration:none; color: red" target="_blank">《{{ item.textname }}》</a>
                        </li>
                    </ul>
                </div>
            </el-form-item>
            <el-form-item>
                <div style="width:50%;">
                    <el-button
                        type="primary"
                        class="medium"
                        :disabled="time>0"
                        v-on:click="submitInfo('fundInfo')"
                    >
                        立即购买
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">
                        返回
                    </el-button>
                </div>
            </el-form-item>
        </el-form>
        <pdf-popup base64 :visible="pdfVisible" :need-time="needTime" :read-file-info-list="currentFileInfoList" v-on:close="finishReading"></pdf-popup>
        <result v-if="buySuccess" :active="2" :result="result" v-on:return-page="reset" v-on:return-login="$router.push({name:'traderecord'})" />
    </div>
</template>
<script>
import result from "@/components/common/result";
import fundProtocol from "@/components/common/fundProtocol";
import PdfPopup from "@/components/util/pdfPopup";
export default {
    name: "Buy",
    components: {
        result,
        fundProtocol,
        PdfPopup
    },
    data () {
        return {
            // 表单信息
            feeH: "", // 费率信息
            fundInfo: {
                amount: "",
                way: "",
                pay: "",
                sharetype: "",
                pwd: "",
                protocol: ""
            },
            dialogVisible: false,
            btnMsg: "获取短信验证码",
            time: 0, // 验证码再次发送间隔
            isPwdCheck: false, // 是否校验密码
            checkMobile: false, // 短信鉴权验证码显示开关
            pla: "请输入起购金额",
            buySuccess: false, // 购买状态
            result: {// 结果页面信息
                cla: "register-success",
                msg: "您的购买申请已提交成功！",
                btnMsg: "预计11月30日以11月29日净值确认份额，如遇节假日则顺延，请耐心等待",
                special: false,
                btnL: {
                    text: "继续购买",
                    event: "return-page"
                },
                btnR: {
                    text: "查看交易记录",
                    event: "return-login"
                }
            },
            query: null,
            xjbAll: "", // 现金宝总资产
            xjbInfo: [], // 现金宝信息
            fund: {}, // 基金信息获取
            protocol: false,
            bankLists: [], // 银行卡列表
            limit: { text: "起购金额范围为：", min: "0", max: "0" }, // 限额
            rules: {// 校验规则配置
                amount: [
                    { validator: this.amountLimit, trigger: "blur" }
                ],
                pay: [
                    { validator: this.validatePayWay, trigger: "change" }
                ],
                pwd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ],
                protocol: [
                    { validator: this.checkProtocol, trigger: "change" }
                ]
            },
            hasBuy: false,
            feeGate: {},
            xjbSel: {},
            bankInfo: {}, // 校验银行卡信息
            cfmdate: "", // 确认日期
            hadXJB: false, //是否购买现金宝模块，默认未购买
            checkbox: false,
            checkTime: true,
            isReadFileReading: false,
            readFileInfoList: [],//披露文件信息
            readappno: "", //申请单编号
            currentFileInfoList: [],
            pdfVisible: false,
            needTime: false
        };
    },
    watch: {
        "fundInfo.amount" (val) {
            this.isAmount(val);
        },
        "fundInfo.way" (val) {
            this.fundInfo.pay = "";
            if (val === "1") {
                this.fundInfo.pay = this.xjbInfo[0] ? (this.xjbInfo[0].transid + this.xjbInfo[0].xjbfundcode) : "";
            } else if (val === "2" || val === "3") {
                this.getBank();
            }
        },
        "fundInfo.sharetype" (val) {
            if (val === "B") {
                this.feeGate = {};
            }
        },
        "fundInfo.pay" (val) {
            if (this.fundInfo.way === "1") {
                const _x = this.xjbInfo.filter(item => {
                    return item.transid + item.xjbfundcode === val;
                })[0];
                if (_x) {
                    this.xjbSel = _x;
                    const _l = Number(_x.totalasset) > Number(this.fund.xjbmax) ? this.fund.xjbmax : _x.totalasset;
                    this.$set(this.limit, "min", this.fund.xjbmin);
                    this.$set(this.limit, "max", _l);
                } else {
                    this.$set(this.limit, "min", "0");
                    this.$set(this.limit, "max", "0");
                }
                this.pla = this.$util.fmtNum(this.limit.min) + "元起，最多可投" + this.$util.fmtNum(this.limit.max) + "元";
                this.queryRate();
            }
        },
        readFileInfoList: {
            handler: function(obj){
                if (obj.every(function (item) {
                    return item.read;//产品概要强制阅读，其他不用
                })) {
                    this.checkbox = true;
                    //this.checkTime = false;
                }
            },
            deep: true
        },
        checkbox(val) {
            if (val && !this.isReadFileReading && !this.readFileInfoList[0].read) {
                this.currentFileInfoList = [this.readFileInfoList[0]];
                this.needTime = true;
                this.pdfVisible = true;
            }
            if (!val) {
                this.readFileInfoList.forEach(item => item.read = false);
            }
        }
    },
    mounted () {
        this.hadXJB = this.$cache.getStatus("PTXJB") == "1" || this.$cache.getStatus("QCXJB") == "1" ? true : false;
        this.fund = JSON.parse(sessionStorage.getItem(this.$route.name));
        this.isPwdCheck = this.$cache.getPwdCheck(this.fund.way);
        this.getBuyWay();
        this.getFileInfo();
    },
    methods: {
        /* 协议勾选校验 */
        checkProtocol (rule, value, callback) {
            const msg = "请阅读并接受适当性协议";
            this.$util.validateProtocol(rule, value, callback, msg);
        },
        validatePayWay (rule, value, callback) {
            if (!value) {
                callback(new Error("请联系客服添加支付渠道"));
            } else {
                callback();
            }
        },
        // 再次购买重置表单
        reset () {
            this.buySuccess = false;
            this.bankInfo = {};
            this.$set(this.fundInfo, "way", "");
            this.$set(this.fundInfo, "amount", "");
            this.$set(this.fundInfo, "pwd", "");
            this.getBuyWay();
        },
        // 处理限额
        amountLimit (rule, value, callback) {
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        // 处理金额
        isAmount (val) {
            const _val = this.$util.checkAmount(val);
            clearTimeout(this.query);
            this.query = setTimeout(() => {
                this.$set(this.fundInfo, "amount", _val);
                this.queryRate();
            }, 1);
        },
        // 费率入参获取
        queryRate () {
            const _this = this;
            let _d = null;
            if (this.fundInfo.amount > 0 && this.fundInfo.sharetype === "A" && ((this.bankInfo.value && this.fundInfo.way !== "1") || (this.xjbSel.xjbfundcode && this.fundInfo.way === "1")) && this.fund.fundtype !== "2") {
                _d = {
                    fundcode: this.fundInfo.way === "1" ? this.xjbSel.xjbfundcode : this.fund.fundcode,
                    amount: this.fundInfo.amount,
                    channelid: this.fundInfo.way === "1" ? this.xjbSel.channelid : this.bankInfo.value,
                    bizcode: this.fundInfo.way === "1" ? "2" : (this.fundInfo.way === "2" ? "1" : "0"),
                    targetfundcode: this.fundInfo.way === "1" ? this.fund.fundcode : ""
                };
                if (this.fund.comrate) {
                    _d.comratelist = this.fund.comrate;
                }
            }
            this.$util.getFee(_d, res => {
                _this.feeGate = res;
                _this.feeH = "<span class=\"red\">" + _this.$util.fmtNum(_this.feeGate.charge) + "元</span>(<s>" + _this.$util.fmtNum(_this.feeGate.originfee) + "</s>元，为您节省<span class=\"red\">" + _this.$util.fmtNum(_this.feeGate.discount) + "</span>元)";
            });
        },
        //获取披露文件信息
        getFileInfo(){
            var _this = this;
            this.$util.queryReadFileInfo({"tano": this.fund.tano,"fundcode": this.fund.fundcode,"flag": "0"},res=>{
                res.forEach(item => {
                    item.read = false;
                    if(item.texttype.trim() === "1"){//产品概要
                        _this.readFileInfoList.unshift(item);
                    }else{
                        _this.readFileInfoList.push(item);
                    }
                });
            });
        },
        //获取链接点击事件
        getClick(index){
            this.currentFileInfoList = [this.readFileInfoList[index]];
            this.readFileInfoList[index].read = true;
            if (this.currentFileInfoList[0].texttype === "1") {
                this.needTime = true;
            } else {
                this.needTime = false;
            }
            this.pdfVisible = true;
        },
        finishReading () {
            this.pdfVisible = false;
            if (this.currentFileInfoList[0].texttype === "1") {
                this.isReadFileReading = true;
            }
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo (formName) {
            const _this = this;
            if(this.hasBuy)return;
            if(this.readFileInfoList.length !== 0){
                if(!this.checkbox){
                    return this.$alert("根据相关法规要求，请在交易前仔细阅读相关文件，并勾选“我已阅读并同意”选项。","提示", {confirmButtonText: "确定"});
                }
            }
            //获取留痕申请编号
            this.$util.writeFileInfo({
                "readFileInfoList": this.readFileInfoList,
                "fundcode": this.fund.fundcode,
                "tano": this.fund.tano
            }, res=>{
                this.readappno = res;
                _this.$refs[formName].validate(valid => {
                    if (valid) {
                        _this.hasBuy = true;
                        setTimeout(()=>{
                            _this.hasBuy = false;
                        },2000);
                        _this.buyFund();
                    } else {
                        return false;
                    }
                });
            });
        },
        buyFund(){
            const _this = this;
            if(this.readFileInfoList.length > 0 && this.readappno.length === 0){return this.$alert("没有留痕申请编号,操作失败 请联系客服");};
            // 默认参数
            let data = {
                riskwarnflag: _this.fund.riskwarnflag,
                riskmismatchflag: _this.fund.riskmismatchflag,
                highriskwarnflag: _this.fund.highriskwarnflag,
                fundmismatchflag: _this.fund.fundmismatchflag,
                channelid: _this.fundInfo.way === "1" ? "" : _this.bankInfo.value,
                moneyaccount: _this.bankInfo.moneyaccount,
                amount: _this.fundInfo.amount,
                verifycode: this.fundInfo.imgCodeVal,
                tradepwd: _this.$util.enc(_this.fundInfo.pwd),
                readappno: _this.readappno
            };
            let _url = "trade/buy/orderpay";
            // 组合购买基金新增参数
            if (_this.fund.comrate) {
                data.combinationcode = _this.fund.combinationcode || "";
                data.comfundlist = _this.fund.fundcode;
                data.moneyaccount = _this.bankInfo.moneyaccount;
                data.comratelist = _this.fund.comrate;
                data.comtype = "0";
                _url = "trade/buy/orderpay/combine";
            } else { // 普通购买参数添加
                data.targetfundcode = _this.fund.fundcode;
                data.targettano = _this.fund.tano;
                data.targetfundtype = _this.fund.fundtype;
                data.targetfundname = _this.fund.fundname;
                data.payway = _this.fundInfo.way;
                data.sharetype = _this.fundInfo.way === "1" ? _this.xjbInfo[0].sharetype : _this.fundInfo.sharetype;
            }
            if (this.fundInfo.way === "3") {
                this.$util.request("umpf/remittance", {status: "3"}).then(res => {
                    if (res.data) {
                        _this.result.transfer = {
                            acct_name: res.data[0].acct_name.split(/[,，]/)[0],
                            bankid: res.data[0].bankid.split(/[,，]/)[0],
                            cnaps: res.data[0].cnaps.split(/[,，]/)[0],
                            acct_no: res.data[0].acct_no.split(/[,，]/)[0],
                            big_cnaps: res.data[0].big_cnaps.split(/[,，]/)[0],
                            bank_exchange_no: res.data[0].bank_exchange_no.split(/[,，]/)[0]
                        };
                    }
                });
            }
            // 下单
            _this.$util.request(_url, data, "POST").then(res => {
                if (!res.data) {
                    _this.resultMes(res);
                }
                // 获取下单时间
                _this.cfmdate = res.data ? res.data[0].incomecaldate : "";
                // 银行卡支付
                // 组合购买
                if (_this.fund.comrate) {
                    _this.resultMes(res);
                    return;
                }
                _this.resultMes(res);
                // 页面鉴权支付
            });
        },
        // 获取对应银行卡信息
        bankSel (val) {
            const _this = this;
            for (const group of this.bankLists) {
                if (group.options && group.options.length > 0) {
                    for (const bank of group.options) {
                        if (bank.moneyaccount === val) {
                            _this.bankInfo = bank;
                            break;
                        }
                    }
                }
            }
            this.queryRate();
        },
        // 获取现金宝信息
        getBuyWay () {
            const _url = "trade/" + (this.fund.comrate ? "combine" : "buy") + "/buyinfo";
            let _param = { fundcode: this.fund.fundcode };
            if (this.fund.comrate) {
                _param.combinationflag = this.fund.combinationflag ? this.fund.combinationflag : "2"; // 组合申购目前仅支持银行卡购买
                _param.combinationrate = this.fund.comrate;
            }
            this.$util.request(_url, _param).then(res => {
                if (res.data) {
                    this.fund = Object.assign({}, this.fund, res.data[0][0]);
                    if(!this.hadXJB){
                        this.fund.payway = this.fund.payway.replace("1,","");
                    }
                    this.xjbInfo = res.data[1];
                    let _all = 0;
                    this.xjbInfo.forEach(item => {
                        _all += Number(item.totalasset);
                    });
                    this.xjbAll = _all;
                    this.$set(this.fundInfo, "way", this.fund.payway.substr(0, 1));
                    this.$set(this.fundInfo, "sharetype", this.fund.sharetype.substr(0, 1));
                    this.bankLists = res.data[2].length > 0 ? this.$util.getBankArr(res.data[2]) : [];
                }
            });
        },
        // 切换为银行卡支付时数据初始化
        getBank () {
            // 获取银行卡信息
            const _x = this.bankLists[0] ? this.bankLists[0].options[1].moneyaccount : "";
            if (_x) {
                this.$set(this.fundInfo, "pay", _x);
                this.bankSel(_x);
            }
            this.$set(this.limit, "min", this.fund.min);
            this.$set(this.limit, "max", this.fund.max);
            this.pla = this.$util.fmtNum(this.fund.min) + "元起，最多可投" + this.$util.fmtNum(this.fund.max) + "元";
        },
        // 生成确认信息
        resultMes (res) {
            if (res.data) {
                this.result.cla = "register-success";
                this.result.btnMsg = "预计确认：" + this.$util.fmtDate(this.cfmdate) + "， 如遇节假日则顺延，请耐心等待";
            } else {
                this.result.cla = "register-fail";
                this.result.btnMsg = "原因：" + res.msg;
            }
            this.result.msg = "您的" + (this.fundInfo.way === "1" ? "现金宝" : (this.fundInfo.way === "2" ? "" : "汇款")) + "购买申请已受理" + (this.result.cla === "register-fail" ? "失败" : "成功");
            this.buySuccess = true;
        }
    }
};
</script>
<style lang="scss">
.comp-buy {
    padding-bottom: 30px;
    .pwdForm .el-form-item.form-text {
        margin-bottom: 10px;
    }
    .pwdForm .el-form-item.form-nor {
        margin-bottom: 20px;
    }
}
</style>
